//IF NOT SAVE FORM FIRST QUESTION
//START
var formChanged = false;
let ckeditorInstance;

// Detect if form is modify
$('form[name="exit_form"]').on('change input', function(e) {
    if ($(e.target).attr('id') !== 'statusSelect') {
        formChanged = true; // Marca el formulario como modificado si el cambio no fue en el select
    }
});

// Controla el evento beforeunload
window.onbeforeunload = function(e) {
    if (formChanged && !$(e.target.activeElement).is('#upload_button, #save_button')) {
        return '¡Atención! Los cambios no guardados se perderán si abandonas la página.';
    }
};

// Restablece la bandera si se envía el formulario
$('form[name="invoice_form"]').submit(function() {
    formChanged = false;
});
//END

const upload_url = $("input[name='upload_url']").val();

const ckeditorConfig = {
    alignment: {
        options: [ 'left', 'center', 'right', 'justify'],
        default: 'justify'
    },
    simpleUpload: {
        // The URL that the images are uploaded to.
        uploadUrl: upload_url,

        // Enable the XMLHttpRequest.withCredentials property.
        withCredentials: true,

        // Headers sent along with the XMLHttpRequest to the upload server.
        headers: {
            'X-CSRF-TOKEN': 'CSRF-Token',
            Authorization: 'Bearer <JSON Web Token>'
        }
    },
    fontColor: {
        colors:[
            { color: '#000000', label: 'Black' },
            { color: '#4d4d4d', label: 'Dim grey' },
            { color: '#999999', label: 'Grey' },
            { color: '#e6e6e6', label: 'Light grey' },
            { color: '#8B4513', label: 'Brown' },
            { color: '#ff0000', label: 'Red' },
            { color: '#ff7f00', label: 'Orange' },
            { color: '#e6b800', label: 'Golden Yellow' },
            { color: '#008000', label: 'Dark Green' },
            { color: '#007acc', label: 'Bright Blue' },
            { color: '#0000ff', label: 'Blue' },
            { color: '#7f00ff', label: 'Violet' },
            { color: '#ff00ff', label: 'Magenta' },
            { color: '#ff007f', label: 'Rose' }
        ],
        colorPicker: {
            // Use 'hex' format for output instead of 'hsl'.
            format: 'hex'
        }
    },
    contentsCss: '/css/content.css',
};

function registerLineItemEditor(editor, element) {
    if (!element || !element.id) return;

    window.lineItemEditors = window.lineItemEditors || {};
    window.lineItemEditors[element.id] = editor;

    const setActiveEditor = function () {
        window.activeLineItemEditor = editor;
    };

    // InlineEditor mantiene el elemento original como área editable. Escuchar
    // sus eventos nativos es más fiable que depender solo del foco interno.
    element.addEventListener('mousedown', setActiveEditor);
    element.addEventListener('focusin', setActiveEditor);

    editor.editing.view.document.on('change:isFocused', function (_event, _name, isFocused) {
        if (isFocused) {
            setActiveEditor();
        }
    });
}

$('.inline-editor').each(function () {
    const editorId = $(this).data('editor-id');


    InlineEditor
        .create(this, ckeditorConfig)
        .then(editor => {
            registerLineItemEditor(editor, this);
            editor.model.document.on('change:data', () => {
                // Actualiza el contenido del textarea asociado
                $(`#${editorId}`).val(editor.getData());
            });
        })
        .catch(error => {
            console.error(error);
        });
});

document.addEventListener('keydown', function(event) {


    if (event.ctrlKey && event.altKey && event.key === 'ArrowUp') {


        event.preventDefault();

        document.getElementById('save_button').click();
    }
});




$(document).ready(function () {


    $('form[name="exit_form"]').on('keydown', 'input' , function(event) {
        // Verificar si la tecla Enter fue presionada
        if (event.key === 'Enter') {
            // Prevenir el comportamiento por defecto del Enter
            event.preventDefault();
        }
    });



const editor = InlineEditor
        .create( document.querySelector( '#editor' ), ckeditorConfig )
        .then(editor => {
                editor.model.document.on('change:data', () => {
                    $('#editor1').val(editor.getData());
                });
                $('#editor1').on('input', function () {
                    editor.setData($(this).val());
                });
                editor.execute( 'alignment', { value: 'justify' } );
            })
        .catch( error => {
            /* console.error( error ); */
        } );

        let editor2Instance = null;
        const editor2El =
            document.getElementById('invoiceEmailEditor') ||
            document.getElementById('budgetEmailEditor') ||
            document.getElementById('editor2');
        const editor3El =
            document.getElementById('invoiceEmailEditorInput') ||
            document.getElementById('budgetEmailEditorInput') ||
            document.getElementById('editor3');
        const editor2Modal = editor2El ? editor2El.closest('.modal') : null;

        function markEditor2Initialized(isInitialized) {
            if (!editor2El) return;
            if (isInitialized) {
                editor2El.dataset.ckeditorInitialized = 'true';
            } else {
                delete editor2El.dataset.ckeditorInitialized;
            }
        }

        function initEditor2() {
            if (!editor2El || !editor3El) return;
            if (editor2El.dataset.ckeditorInitialized === 'true') return;

            InlineEditor
                .create(editor2El, ckeditorConfig)
                .then(editor => {
                    editor2Instance = editor;
                    window.ckeditorInstance = editor;
                    markEditor2Initialized(true);

                    editor.model.document.on('change:data', () => {
                        if (editor3El) {
                            editor3El.value = editor.getData();
                        }
                    });
                    if (editor3El) {
                        $(editor3El).on('input', function () {
                            editor.setData($(this).val());
                        });
                    }

                    editor.execute('alignment', { value: 'justify' });
                })
                .catch(error => {
                    /* console.error( error ); */
                });
        }

        function destroyEditor2() {
            if (!editor2Instance) return;
            editor2Instance.destroy()
                .then(() => {
                    editor2Instance = null;
                    markEditor2Initialized(false);
                })
                .catch(() => {});
        }

        if (editor2El) {
            const isInModal = !!editor2El.closest('.modal');
            if (!isInModal) {
                initEditor2();
            } else if (editor2Modal) {
                $(editor2Modal).on('shown.bs.modal', function () {
                    initEditor2();
                });
                $(editor2Modal).on('hidden.bs.modal', function () {
                    destroyEditor2();
                });
            } else {
                initEditor2();
            }
        }

    function initializeCKEditor(element) {
        const editorId = $(element).data('editor-id');
        InlineEditor
            .create(element, ckeditorConfig)
            .then(editor => {
                registerLineItemEditor(editor, element);
                editor.model.document.on('change:data', () => {
                    // Actualiza el contenido del textarea asociado
                    $(`#${editorId}`).val(editor.getData());
                });
                editor.execute( 'alignment', { value: 'justify' } );
            })
            .catch(error => {
                console.error(error);
            });
    }

    function initializeAllCKEditors() {
        $('.inline-editor').each(function () {
            const editorId = $(this).data('editor-id');

            InlineEditor
                .create(this, ckeditorConfig)
                .then(editor => {
                    registerLineItemEditor(editor, this);
                    editor.model.document.on('change:data', () => {
                        // Actualiza el contenido del textarea asociado
                        $(`#${editorId}`).val(editor.getData());
                    });
                    editor.execute( 'alignment', { value: 'justify' } );
                })
                .catch(error => {
                    console.error(error);
                });
        });
    }



    // Inicializar CKEditor para textareas con la clase .ckeditor_budgets
    function initializeCKEditorBudgets(textarea) {
        InlineEditor
            .create(textarea, ckeditorConfig)
            .then(editor => {
                editor.execute( 'alignment', { value: 'justify' } );
                console.log('Editor (ckeditor_budgets) was initialized', editor);
            })
            .catch(error => {
                console.error(error);
            });
    }

    $('.inline-editor').each(function () {
        initializeCKEditor(this);
    });

    // Variable para rastrear el editor actual de CKEditor_budgets
    let ckeditor_budgets_editor = null;

    // Función para destruir CKEditor_budgets actual
    function destroyCKEditorBudgets() {
        if (ckeditor_budgets_editor) {
            ckeditor_budgets_editor.destroy()
                .then(() => {
                    console.log('Editor (ckeditor_budgets) destroyed successfully');
                    ckeditor_budgets_editor = null;
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    // Inicializar CKEditor_budgets para textareas con la clase .ckeditor_budgets
    function initializeCKEditorBudgets(textarea) {
        destroyCKEditorBudgets(); // Destruir el editor existente
        InlineEditor
            .create(textarea, ckeditorConfig)
            .then(editor => {
                console.log('Editor (ckeditor_budgets) was initialized', editor);
                ckeditor_budgets_editor = editor; // Rastrear el nuevo editor
                editor.execute( 'alignment', { value: 'justify' } );
            })
            .catch(error => {
                console.error(error);
            });
    }

    // Agregar evento de clic personalizado para textareas con la clase .ckeditor_budgets
    $('#editableTable').on('click', 'textarea.ckeditor_budgets', function () {
        initializeCKEditorBudgets(this);
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#addRowBtn').on('click', function () {

        var formData = {
            budget_id: $('input[name="budget_id"]').val(),
            date_budget: $('input[name="date_budget"]').val(),
            date_validity: $('input[name="date_validity"]').val(),
            control: $('input[name="control"]').val(),
            supply: $('input[name="supply"]').val(),
            delivery_time: $('textarea[name="delivery_time"]').val(),
            acceptance: $('textarea[name="acceptance"]').val(),
            cantidad: $('input[name="cantidad[]"]').map(function () { return $(this).val(); }).get(),
            descripcion: $('textarea[name="descripcion[]"]').map(function () { return $(this).val(); }).get(),
            precio: $('input[name="precio[]"]').map(function () { return $(this).val(); }).get(),
            _token: $('input[name="_token"]').val()
        };

        var budgetId = $('#budget_id').val();
        $.ajax({
            url: '/presupuestos/ajax_update/' + budgetId,
            type: 'POST',
            data: formData,
            success: function (response) {
            },
            error: function (xhr, status, error) {
                console.log('Estado:', status);
                console.log('Error:', error);
                console.log('Respuesta:', xhr.responseText);
            }
        });
        var index = $('#editableTable tbody tr').length;
        var newRow = '<tr>' +
            '<td valign="top"><span class="sortable-handle" style="cursor: move;"><i class="las la-arrows-alt"></i></span></td>' +
            '<td valign="top"><input type="text" class="editable form-control calculate" name="cantidad[]" style="width: 100px" value=""></td>' +
            '<td valign="top"><div id="editor' + index + '" class="editable description ckeditor_budgets inline-editor" data-editor-id="textareaId' + index + '"></div><textarea type="text" class="editable description ckeditor_budgets" name="descripcion[]" id="textareaId' + index + '" style="display: none"></textarea></td>' +
            '<td valign="top"><input type="number" class="editable form-control calculate" name="precio[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
            '<td valign="top"><span class="delete-row"><i class="las la-trash-alt"></i></span></td>'
            '</tr>';

        $('#editableTable tbody').append(newRow);

        // Vuelve a inicializar todos los editores CKEditor después de agregar la nueva fila
        initializeAllCKEditors();
    });

    $('#addRowBtn2').on('click', function () {

        var formData = {
            invoice_id: $('input[name="invoice_id"]').val(),
            date_invoice: $('input[name="date_invoice"]').val(),
            reference: $('input[name="reference"]').val(),
            number: $('input[name="number"]').val(),

            cantidad: $('input[name="cantidad[]"]').map(function () { return $(this).val(); }).get(),
            descripcion: $('textarea[name="descripcion[]"]').map(function () { return $(this).val(); }).get(),
            precio: $('input[name="precio[]"]').map(function () { return $(this).val(); }).get(),
            _token: $('input[name="_token"]').val()
        };

        var invoice_id = $('#invoice_id').val();
        $.ajax({
            url: '/facturas/ajax_update/' + invoice_id,
            type: 'POST',
            data: formData,
            success: function (response) {
            },
            error: function (xhr, status, error) {
                console.log('Estado:', status);
                console.log('Error:', error);
                console.log('Respuesta:', xhr.responseText);
            }
        });
        var index = $('#editableTable tbody tr').length;
        var newRow = '<tr>' +
            '<td valign="top"><span class="sortable-handle" style="cursor: move;"><i class="las la-arrows-alt"></i></span></td>' +
            '<td valign="top"><input type="text" class="editable form-control calculate" name="cantidad[]" style="width: 100px" value=""></td>' +
            '<td valign="top"><div id="editor' + index + '" class="editable description ckeditor_budgets inline-editor" data-editor-id="textareaId' + index + '"></div><textarea type="text" class="editable description ckeditor_budgets" name="descripcion[]" id="textareaId' + index + '" style="display: none"></textarea></td>' +
            '<td valign="top"><input type="number" class="editable form-control calculate" name="precio[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
            '<td valign="top"><span class="delete-row"><i class="las la-trash-alt"></i></span></td>'
            '</tr>';

        $('#editableTable tbody').append(newRow);

        // Vuelve a inicializar todos los editores CKEditor después de agregar la nueva fila
        initializeAllCKEditors();
    });

    // Agregar evento de clic para destruir CKEditor
    $('[data-action="destroy_ckeditor"]').click(function () {
        destroyCKEditorBudgets();
    });


    $('#addRowBtn3').on('click', function () {

        // var formData = {
        //     invoice_id: $('input[name="invoice_id"]').val(),
        //     date_invoice: $('input[name="date_invoice"]').val(),
        //     reference: $('input[name="reference"]').val(),
        //     number: $('input[name="number"]').val(),

        //     cantidad: $('input[name="cantidad[]"]').map(function () { return $(this).val(); }).get(),
        //     descripcion: $('textarea[name="descripcion[]"]').map(function () { return $(this).val(); }).get(),
        //     precio: $('input[name="precio[]"]').map(function () { return $(this).val(); }).get(),
        //     _token: $('input[name="_token"]').val()
        // };

        // var invoice_id = $('#invoice_id').val();
        // $.ajax({
        //     url: '/facturas/ajax_update/' + invoice_id,
        //     type: 'POST',
        //     data: formData,
        //     success: function (response) {
        //     },
        //     error: function (xhr, status, error) {
        //         console.log('Estado:', status);
        //         console.log('Error:', error);
        //         console.log('Respuesta:', xhr.responseText);
        //     }
        // });
        var index = $('#editableTable tbody tr').length;
        var newRow = '<tr>' +
        '<td valign="top"><span class="sortable-handle" style="cursor: move;"><i class="las la-arrows-alt"></i></span></td>' +
        '<td valign="top"><input type="text" class="editable form-control calculate" name="ot[]" style="width: 100px" value=""></td>' +
        '<td valign="top"><input type="text" class="editable form-control calculate" name="reference[]" style="width: 200px" value=""></td>' +
        '<td valign="top"><textarea type="text" class="editable description" name="description[]" id="descripcion" style="width: 420px"  rows="5"></textarea></td>' +
        '<td valign="top"><input type="number" class="editable form-control calculate" name="unit[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
        '<td valign="top"><input type="number" class="editable form-control calculate" name="price[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
        '<td valign="top"><input type="number" class="editable form-control calculate" name="discount[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
        '<td valign="top"><input type="number" class="editable form-control calculate" name="total[]" oninput="validarFormato(this)" style="width: 100px" value="0"></td>' +
        '<td valign="top"><span class="delete-row"><i class="las la-trash-alt"></i></span></td>'
        '</tr>';

        $('#editableTable tbody').append(newRow);
    });
});
